<template>
    <router-link :to="{ name: 'edit-profile' }">Edit Profile</router-link>
</template>

<script>
    export default {
        name: "EditProfileButton",
    }
</script>